import React, { useEffect } from 'react';

const Blog7: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <article className="max-w-6xl mx-auto p-6 mt-28 bg-white shadow-lg rounded-lg mb-8">
            <h1 className="text-3xl font-bold mb-2">Endoscopic Brain Surgery Explained – Nose-to-Tumor Path for Safer, Scar-Free Healing</h1>
            <div className="text-gray-600 mb-4">
                🗓️ <span>25th February, 2026</span>
            </div>

            <img src='/images/blog7.png' alt="Endoscopic Brain Surgery" className="w-full h-80 object-contain rounded-lg mb-6" />

            <div className="prose max-w-none">
                <p>
                    Endoscopic endonasal surgery is an advanced minimally invasive technique that accesses the skull base through natural nasal corridors. Commonly utilized for pituitary adenomas, craniopharyngiomas, and selected chordomas or meningiomas, this approach avoids large external cranial incisions and brain retraction, minimizing disruption to surrounding neural structures.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Symptoms and Preoperative Evaluation</h2>
                <p>
                    Clinical indicators warranting evaluation include progressive visual field deficits (bitemporal hemianopsia), persistent unexplained headaches, and endocrine imbalances. High-resolution MRI and fine-cut CT angiography are obtained to map sphenoid sinus anatomy, internal carotid artery course, and optic chiasm relationships before surgical planning.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">The Surgical Procedure</h2>
                <p>
                    Procedures are frequently performed via a multidisciplinary team involving neurosurgery and otorhinolaryngology (ENT). High-definition 4K endoscopes and micro-instruments allow panoramic visualization of the sella and suprasellar space, while neuronavigation tracks spatial orientation in real-time. Reconstruction of the skull base with vascularized mucosal flaps helps prevent cerebrospinal fluid (CSF) leaks.
                </p>

                <h2 className="text-2xl font-semibold mt-6 mb-3">Postoperative Care & Recovery</h2>
                <p>
                    Post-surgical monitoring includes close assessment of electrolyte and endocrine balance, nasal care protocols, and structured follow-up. Serial MRI studies and endocrinology reviews are conducted to evaluate hormonal regulation and ensure long-term clinical safety.
                </p>
            </div>

            <button className="mt-6 bg-blue-800 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
                Schedule Appointment
            </button>
        </article>
    );
};

export default Blog7;
